// 会员套餐类型
export type SubscriptionTier = "free" | "basic" | "pro" | "ultra";

// 套餐配置
export interface SubscriptionPlan {
  id: SubscriptionTier;
  name: string;
  price: number;
  priceId?: string; // Stripe Price ID
  features: string[];
  limits: {
    deepseek: number | "unlimited"; // 每日次数，"unlimited" 表示无限
    gpt4o: number | "unlimited";
    imageGeneration: number | "unlimited";
  };
}

// 套餐详情
export const SUBSCRIPTION_PLANS: Record<SubscriptionTier, SubscriptionPlan> = {
  free: {
    id: "free",
    name: "免费版",
    price: 0,
    features: [
      "每日 10 次对话",
      "仅限 DeepSeek 模型",
      "基础人格创建",
    ],
    limits: {
      deepseek: 10,
      gpt4o: 0,
      imageGeneration: 0,
    },
  },
  basic: {
    id: "basic",
    name: "Basic",
    price: 4.9,
    features: [
      "DeepSeek 无限对话",
      "图片理解功能",
      "创建无限人格",
      "优先客服支持",
    ],
    limits: {
      deepseek: "unlimited",
      gpt4o: 0,
      imageGeneration: 0,
    },
  },
  pro: {
    id: "pro",
    name: "Pro",
    price: 9.9,
    features: [
      "DeepSeek 无限对话",
      "GPT-4o 每日 50 次",
      "图片生成每日 20 张",
      "所有高级功能",
    ],
    limits: {
      deepseek: "unlimited",
      gpt4o: 50,
      imageGeneration: 20,
    },
  },
  ultra: {
    id: "ultra",
    name: "Ultra",
    price: 19.9,
    features: [
      "所有模型无限对话",
      "图片生成无限",
      "优先响应速度",
      "专属客服通道",
      "新功能优先体验",
    ],
    limits: {
      deepseek: "unlimited",
      gpt4o: "unlimited",
      imageGeneration: "unlimited",
    },
  },
};

// 用户订阅状态
export interface UserSubscription {
  tier: SubscriptionTier;
  startDate: string;
  endDate?: string; // 订阅到期时间，undefined 表示永久（如免费版）
  stripeSubscriptionId?: string; // Stripe 订阅 ID
  stripeCustomerId?: string; // Stripe 客户 ID
}

// 用户每日使用量
export interface DailyUsage {
  date: string; // YYYY-MM-DD
  deepseekCount: number;
  gpt4oCount: number;
  imageGenerationCount: number;
}

// 用户会员数据（存储在 Clerk metadata）
export interface UserMembershipData {
  subscription: UserSubscription;
  dailyUsage: DailyUsage;
}
